module.exports = __webpack_public_path__ + "static/tuples.1cd77544.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/tuples.png
// module id = 716
// module chunks = 23899280101116